export const media = {
  modal: {
    remove: {
      content: `Anda yakin ingin menghapus file <b>{description}<b>?`
    }
  },

  list: {
    button_upload: 'unggah file',
    add_media: 'Tambahkan file media'
  },

  table: {
    field: {
      play: 'Play',
      created_at: 'unggah pada'
    }
  }
};
